// Pages/Projects.js
import React from 'react';
import './Project.css';

const Projects = () => {
  return (
    <div className="projects-section" id="projects">
      <h2 className="section-title">
        <span role="img" aria-label="rocket">🚀</span>My Projects
      </h2>

      <div className="projects-container">
        <div className="project-card">
          <img
            src="/Task.jpg" // or your own image path
            alt="Task Management System"
            className="project-image"
          />
          <h3 className="project-title">Task Management System</h3>

          <a
            href="https://github.com/Viru-mhatre/Task-Management-System"
            className="project-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </div>
      </div>

      </div>
  );
};

export default Projects;
